export function sin(float) {
    return Math.sin(float)
}

export function pi() {
    return Math.PI
}

export function acos(float) {
    return Math.acos(float)
}

export function acosh(float) {
    return Math.acosh(float)
}

export function asin(float) {
    return Math.asin(float)
}

export function asinh(float) {
    return Math.asinh(float)
}

export function atan(float) {
    return Math.atan(float)
}

export function tan(float) {
    return Math.tan(float)
}

export function atan2(floaty, floatx) {
    return Math.atan2(floaty, floatx)
}

export function atanh(float) {
    return Math.atanh(float)
}

export function cos(float) {
    return Math.cos(float)
}

export function cosh(float) {
    return Math.cosh(float)
}

export function exponential(float) {
    return Math.exp(float)
}

export function ceiling(float) {
    return Math.ceil(float)
}

export function floor(float) {
    return Math.floor(float)
}

export function power(base, exponent) {
    return Math.pow(base, exponent)
}

export function logarithm(float) {
    return Math.log(float)
}

export function logarithm_10(float) {
    return Math.log10(float)
}

export function logarithm_2(float) {
    return Math.log2(float)
}

export function sinh(float) {
    return Math.sinh(float)
}

export function tanh(float) {
    return Math.tanh(float)
}

export function sign(float) {
    return Math.sign(float)
}

export function truncate(float) {
    return Math.trunc(float)
}

export function to_int(float) {
    return Math.trunc(float)
}
